export default {
  validate(formData) {
    const errors = {};

    if (!formData.inspector?.name?.trim()) {
      errors.inspector_name = 'Name is required';
    }
    if (!formData.inspector?.address?.trim()) {
      errors.inspector_address = 'Address is required';
    }
    if (!formData.inspector?.postCode?.trim()) {
      errors.inspector_postCode = 'Post Code is required';
    }
    if (!formData.inspector?.tel?.trim()) {
      errors.inspector_tel = 'Telephone is required';
    }
    if (!formData.inspector?.gasRegNumber?.trim()) {
      errors.inspector_gasRegNumber = 'Gas Safe Reg No. is required';
    }
    if (!formData.property?.address?.trim()) {
      errors.property_address = 'Property Address is required';
    }
    if (!formData.property?.postCode?.trim()) {
      errors.property_postCode = 'Post Code is required';
    }
    if (!formData.property?.landlord?.trim()) {
      errors.property_landlord = 'Landlord Name is required';
    }
    if (!formData.certification?.inspectionDate?.trim()) {
      errors.certification_inspectionDate = 'Inspection Date is required';
    }
    if (!formData.certification?.nextInspectionDate?.trim()) {
      errors.certification_nextInspectionDate = 'Next Inspection Due is required';
    }
    if (!formData.certification?.certificateNumber?.trim()) {
      errors.certification_certificateNumber = 'Certificate Number is required';
    }
    if (!formData.certification?.engineerSignature?.trim()) {
      errors.certification_engineerSignature = 'Engineer Signature is required';
    }
    if (!formData.certification?.engineerName?.trim()) {
      errors.certification_engineerName = 'Engineer Name (Print) is required';
    }

    return {
      isValid: Object.keys(errors).length === 0,
      errors
    };
  }
};
